module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/payoneer-7ab0fd0c1322f7947347f06856cb399a.svg";